import $http from "@/plugins/axios"

export default {
    state: {
        names: [],
    },
    getters: {
        names: state => state.names
    },
    actions: {
        async getListNames({ commit }, path) {
            const response = await $http.get(path)
            commit("SET_ITEMS", response.data)
        },
    },
    mutations: {
        SET_ITEMS(state, data) {
            state.names = data
        }
    }
}